import React from 'react';
const projectList = [
  {
    name: 'Tic-Tac-Toe',
    description: (
      <p>
        My first game utilizes an algorithm to allow the user to compete against a bot! Tic-Tac-Toe also features the ability to play against friends over the internet. This project was fun because it allowed me to incorporate something math related into an app, which was challenging.
         Check out this{' '}
        <a
          href='https://github.com/hernandez-crypto/ttt-client/blob/master/src/components/Tic-Tac-Toe/Offline/ComputerPlayer.js'
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: 'green' }}
        >
          link
        </a>{' '}
        to see to see how it was built!
      </p>
    ),
    stack: [
      'react-plain',
      'css3-plain',
      'javascript-plain',
      'express-original',
      'nodejs-plain',
      'heroku-plain',
      'postgresql-plain',
    ],
    imageLink: 'ticTacToe.png',
    liveSite: 'https://ttt-client.hernandezjulio58.now.sh/',
    clientURL: 'https://github.com/hernandez-crypto/ttt-client',
    serverURL: 'https://github.com/hernandez-crypto/ttt-server',
  },
  {
    name: 'Live List',
    description: (
      <p>
        Live List is an app created by a team of five developers for coding boot camp. I mainly worked on testing for both the client and server but also assisted with styling and hooking up some endpoints. I learned Cypress, an end-to-end testing framework for this project.
      </p>
    ),
    stack: [
      'react-plain',
      'css3-plain',
      'javascript-plain',
      'express-original',
      'nodejs-plain',
      'heroku-plain',
      'postgresql-plain',
    ],
    imageLink: 'liveList.png',
    liveSite: 'https://social-playlist.netlify.com/',
    clientURL: 'https://github.com/thinkful-ei-heron/SocialPlaylist-Client',
    serverURL: 'https://github.com/thinkful-ei-heron/SocialPlaylist-server',
  },
  {
    name: 'Spaced Repetition',
    description: (
      <p>
        Spaced Repetition is an app with the goal of assisted learning. After users have signed up, quizzing results in the database sorting itself differently to prioritize the bits of information that are known the least.
         Developed with a partner :{' '}
        <a
          href='https://github.com/shannon-lichtenwalter'
          target='_blank'
          rel='noopener noreferrer'
        >
          Shannon Lichtenwalter
        </a>
        .
      </p>
    ),
    stack: [
      'react-plain',
      'css3-plain',
      'javascript-plain',
      'express-original',
      'nodejs-plain',
      'heroku-plain',
      'postgresql-plain',
    ],
    imageLink: 'spacedRepetition.png',
    liveSite: 'https://spaced-repetition-julio-shannon-client.now.sh/',
    clientURL:
      'https://github.com/thinkful-ei-heron/spaced-repetition-Julio-Shannon-client',
    serverURL:
      'https://github.com/thinkful-ei-heron/spaced-repetition-Julio-Shannon-server',
  },
  {
    name: 'Bookmarker 9000',
    description: (
      <p>
        Bookmarker 9000 is a full-stack web app built to store URLs. Naming inspired by <i>Phineas and Ferb</i>'s antagonist: Dr. Doofenshmirtz, Bookmarker 9000 stores all the URLs', menacingly!
      </p>
    ),
    stack: [
      'html5-plain',
      'css3-plain',
      'javascript-plain',
      'express-original',
      'nodejs-plain',
      'heroku-plain',
      'postgresql-plain',
    ],
    imageLink: 'bookmarker.png',
    liveSite: 'https://thinkful-ei-heron.github.io/julio-bookmark-v2/',
    clientURL: 'https://github.com/thinkful-ei-heron/julio-bookmark-v2',
    serverURL: 'https://github.com/hernandez-crypto/bookmark-server',
  },
  {
    name: 'Waitstaff Calculator',
    description: (
      <p>
        Waitstaff Calculator is a static web app built to learn about React state management. Too tired to calculate how much the customer needs to pay at the end of a bill? The Waitstaff Calculator is here to clear the cognitive load and make the waiteresses'/waiters' jobs easier.
      </p>
    ),
    stack: ['react-plain', 'css3-plain', 'javascript-plain'],
    imageLink: 'waitStaffCalc.png',
    liveSite: 'https://hernandez-crypto.github.io/waitstaff-calculator/',
    clientURL: 'https://github.com/hernandez-crypto/waitstaff-calculator',
  },

  {
    name: 'The Office Quiz',
    description: (
      <p>
        The Office Quiz is a short quiz that tests your knowledge of the show <i>The Office</i>. Being my first app, it isn't too flashy but did require learning app architecture and a bit about react to work.
         Developed with a partner :{' '}
        <a
          href='https://github.com/wjacobs71086'
          target='_blank'
          rel='noopener noreferrer'
        >
          Wesley Jacobs
        </a>
        .
      </p>
    ),
    stack: ['html5-plain', 'css3-plain', 'javascript-plain'],
    imageLink: 'theOfficeQuiz.png',
    liveSite: 'https://thinkful-ei-heron.github.io/q-app-julio-wesley/',
    clientURL: 'https://github.com/thinkful-ei-heron/q-app-julio-wesley',
  },
];
export default projectList;
